import { useState , useEffect } from "react";
import styled from "styled-components";
import api from "../../../services/api";
import { mascaraCep, mascaraCnpj, mascaraTelefone, } from "../../../utils/masks";
import { buscarCep } from "../../../utils/cep";
import { toast } from "react-toastify";

export default function Empresas() {
  const [tiposEmpresa, setTiposEmpresa] = useState([]);
  const [carregandoTipos, setCarregandoTipos] = useState(false);
  const [exibirFormulario, setExibirFormulario] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [erroCep, setErroCep] = useState("");

  const [form, setForm] = useState({
    empresa_tipo_id: "",
    razao_social: "",
    nome_fantasia: "",
    cnpj: "",
    telefone: "",
    email: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    cep: "",
    logo: "",
    ativo: true,
  });

  function handleChange(event) {
    const { name, value, type, checked } = event.target;

    let novoValor = type === "checkbox" ? checked : value;

    switch (name) {
      case "cep":
        novoValor = mascaraCep(value);
        break;

      case "cnpj":
        novoValor = mascaraCnpj(value);
        break;

      case "telefone":
        novoValor = mascaraTelefone(value);
        break;

      default:
        break;
    }

    setForm((prev) => ({
      ...prev,
      [name]: novoValor,
    }));
  }
  async function handleSubmit(event) {
    event.preventDefault();

    try {
      const response = await api.post("/api/empresas", form);

      toast.success(
        response.data.message || "Empresa cadastrada com sucesso!"
      );

      limpaDados();
      setExibirFormulario(false);

    } catch (error) {
      console.error("Erro ao cadastrar empresa:", error);

      if (error.response?.status === 422) {
        const erros = error.response.data.errors;

        const primeiroErro = Object.values(erros)?.[0]?.[0];

        toast.error(
          primeiroErro || "Verifique os dados informados."
        );

        return;
      }

      toast.error("Não foi possível cadastrar a empresa.");
    }
  }

  function cancelarFormulario() {
    setExibirFormulario(false);
    limpaDados();
  }

  async function consultarCep() {
    if (!form.cep) {
      setErroCep("");
      return;
    }

    try {
      setBuscandoCep(true);
      setErroCep("");

      const dados = await buscarCep(form.cep);

      setForm((prev) => ({
        ...prev,
        cep: dados.cep,
        endereco: dados.endereco,
        bairro: dados.bairro,
        cidade: dados.cidade,
        estado: dados.estado,
      }));
    } catch (error) {
      setErroCep(error.message);
    } finally {
      setBuscandoCep(false);
    }
  }

  function limpaDados(){
    setForm({
      empresa_tipo_id: "",
      razao_social: "",
      nome_fantasia: "",
      cnpj: "",
      telefone: "",
      email: "",
      endereco: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      estado: "",
      cep: "",
      logo: "",
      ativo: true,
    });
  }


  useEffect(() => {
    carregarTiposEmpresa();
  }, []);

  async function carregarTiposEmpresa() {
    try {
      setCarregandoTipos(true);

      const response = await api.get("/api/empresa-tipos");

      setTiposEmpresa(response.data.tipos);
    } catch (error) {
      console.error("Erro ao carregar tipos de empresa:", error);
    } finally {
      setCarregandoTipos(false);
    }
  }

  return (
    <PageContainer>
      <PageHeader>
        <div>
          <h1>Empresas</h1>
          <p>Cadastro e gerenciamento das empresas do sistema.</p>
        </div>

        {!exibirFormulario && (
          <PrimaryButton
            type="button"
            onClick={() => setExibirFormulario(true)}
          >
            Nova Empresa
          </PrimaryButton>
        )}
      </PageHeader>

      {exibirFormulario ? (
        <ContentCard>
          <FormHeader>
            <div>
              <h2>Nova Empresa</h2>
              <p>Preencha os dados da empresa.</p>
            </div>
          </FormHeader>

          <Form onSubmit={handleSubmit}>
            <SectionTitle>Dados da empresa</SectionTitle>

            <FormGrid>
              <FormGroup>
                <label htmlFor="empresa_tipo_id">
                  Tipo da Empresa *
                </label>
                  <select
                    id="empresa_tipo_id"
                    name="empresa_tipo_id"
                    value={form.empresa_tipo_id}
                    onChange={handleChange}
                    disabled={carregandoTipos}
                    required
                  >
                    <option value="">
                      {carregandoTipos ? "Carregando..." : "Selecione..."}
                    </option>

                    {tiposEmpresa.map((tipo) => (
                      <option
                        key={tipo.id}
                        value={tipo.id}
                      >
                        {tipo.nome}
                      </option>
                    ))}
                  </select>
              </FormGroup>

              <FormGroup>
                <label htmlFor="cnpj">CNPJ *</label>

                  <input
                    id="cnpj"
                    name="cnpj"
                    type="text"
                    inputMode="numeric"
                    value={form.cnpj}
                    onChange={handleChange}
                    placeholder="00.000.000/0000-00"
                    maxLength={18}
                    required
                  />  
              </FormGroup>

              <FormGroup $span={2}>
                <label htmlFor="razao_social">Razão Social *</label>

                <input
                  id="razao_social"
                  name="razao_social"
                  type="text"
                  value={form.razao_social}
                  onChange={handleChange}
                  placeholder="Razão social da empresa"
                  required
                />
              </FormGroup>

              <FormGroup $span={2}>
                <label htmlFor="nome_fantasia">Nome Fantasia *</label>

                <input
                  id="nome_fantasia"
                  name="nome_fantasia"
                  type="text"
                  value={form.nome_fantasia}
                  onChange={handleChange}
                  placeholder="Nome fantasia"
                  required
                />
              </FormGroup>
            </FormGrid>

            <SectionTitle>Contato</SectionTitle>

            <FormGrid>
              <FormGroup>
                <label htmlFor="telefone">Telefone</label>

                <input
                  id="telefone"
                  name="telefone"
                  type="text"
                  inputMode="numeric"
                  value={form.telefone}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                  maxLength={15}
                />
              </FormGroup>

              <FormGroup>
                <label htmlFor="email">E-mail</label>

                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="empresa@email.com"
                />
              </FormGroup>
            </FormGrid>

            <SectionTitle>Endereço</SectionTitle>

            <FormGrid>
              <FormGroup $span={2}>
                <label htmlFor="cep">CEP</label>

                  <input
                    id="cep"
                    name="cep"
                    type="text"
                    inputMode="numeric"
                    value={form.cep}
                    onChange={handleChange}
                    onBlur={consultarCep}
                    placeholder="00000-000"
                    maxLength={9}
                  />

                {buscandoCep && (
                  <FieldInfo>
                    Consultando CEP...
                  </FieldInfo>
                )}

                {erroCep && (
                  <FieldError>
                    {erroCep}
                  </FieldError>
                )}
              </FormGroup>

              <FormGroup $span={3}>
                <label htmlFor="endereco">Endereço</label>

                <input
                  id="endereco"
                  name="endereco"
                  type="text"
                  value={form.endereco}
                  onChange={handleChange}
                  placeholder="Rua, avenida..."
                />
              </FormGroup>

              <FormGroup>
                <label htmlFor="numero">Número</label>

                <input
                  id="numero"
                  name="numero"
                  type="text"
                  value={form.numero}
                  onChange={handleChange}
                  placeholder="123"
                />
              </FormGroup>

              <FormGroup $span={2}>
                <label htmlFor="complemento">Complemento</label>

                <input
                  id="complemento"
                  name="complemento"
                  type="text"
                  value={form.complemento}
                  onChange={handleChange}
                  placeholder="Sala, bloco, andar..."
                />
              </FormGroup>

              <FormGroup $span={2}>
                <label htmlFor="bairro">Bairro</label>

                <input
                  id="bairro"
                  name="bairro"
                  type="text"
                  value={form.bairro}
                  onChange={handleChange}
                  placeholder="Bairro"
                />
              </FormGroup>

              <FormGroup $span={2}>
                <label htmlFor="cidade">Cidade</label>

                <input
                  id="cidade"
                  name="cidade"
                  type="text"
                  value={form.cidade}
                  onChange={handleChange}
                  placeholder="Cidade"
                />
              </FormGroup>

              <FormGroup>
                <label htmlFor="estado">UF</label>

                <select
                  id="estado"
                  name="estado"
                  value={form.estado}
                  onChange={handleChange}
                >
                  <option value="">UF</option>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AP">AP</option>
                  <option value="AM">AM</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MT">MT</option>
                  <option value="MS">MS</option>
                  <option value="MG">MG</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PR">PR</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RS">RS</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="SC">SC</option>
                  <option value="SP">SP</option>
                  <option value="SE">SE</option>
                  <option value="TO">TO</option>
                </select>
              </FormGroup>
            </FormGrid>

            <SectionTitle>Configurações</SectionTitle>

            <FormGrid>
              <FormGroup $span={2}>
                <label htmlFor="logo">Logo</label>

                <input
                  id="logo"
                  name="logo"
                  type="text"
                  value={form.logo}
                  onChange={handleChange}
                  placeholder="Logo da empresa"
                />
              </FormGroup>

              <StatusContainer>
                <StatusLabel>
                  <input
                    name="ativo"
                    type="checkbox"
                    checked={form.ativo}
                    onChange={handleChange}
                  />

                  <span>Empresa ativa</span>
                </StatusLabel>

                <small>
                  Empresas inativas não poderão ser utilizadas em novas
                  operações.
                </small>
              </StatusContainer>
            </FormGrid>

            <FormActions>
              <SecondaryButton
                type="button"
                onClick={cancelarFormulario}
              >
                Cancelar
              </SecondaryButton>

              <PrimaryButton type="submit">
                Salvar Empresa
              </PrimaryButton>
            </FormActions>
          </Form>
        </ContentCard>
      ) : (
        <ContentCard>
          <EmptyState>
            <h2>Empresas cadastradas</h2>
            <p>A listagem das empresas será exibida aqui.</p>
          </EmptyState>
        </ContentCard>
      )}
    </PageContainer>
  );
}

export const PageContainer = styled.div`
  padding: 28px;
  width: calc(100vw - 350px);
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 24px;

  h1 {
    margin: 0 0 4px;

    font-size: 26px;
    color: #263238;
  }

  p {
    margin: 0;

    color: #7a858f;
    font-size: 14px;
  }
`;

export const PrimaryButton = styled.button`
  border: none;

  background: #2e7d6e;
  color: #ffffff;

  padding: 11px 18px;

  border-radius: 8px;

  font-size: 14px;
  font-weight: 600;

  cursor: pointer;

  transition:
    background 0.2s ease,
    transform 0.15s ease;

  &:hover {
    background: #25685c;
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const ContentCard = styled.div`
  background: #ffffff;

  border: 1px solid #e6e9ef;

  border-radius: 12px;

  min-height: 300px;

  padding: 24px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
`;

export const EmptyState = styled.div`
  h2 {
    margin: 0 0 6px;

    font-size: 18px;
    color: #39434d;
  }

  p {
    margin: 0;

    color: #8a949d;
    font-size: 14px;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-bottom: 20px;
  margin-bottom: 24px;

  border-bottom: 1px solid #edf0f3;

  h2 {
    margin: 0 0 5px;

    color: #39434d;
    font-size: 20px;
  }

  p {
    margin: 0;

    color: #8a949d;
    font-size: 14px;
  }
`;

export const Form = styled.form`
  width: 100%;
`;

export const SectionTitle = styled.h3`
  margin: 26px 0 16px;

  color: #2e7d6e;

  font-size: 14px;
  font-weight: 600;

  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const FormGrid = styled.div`
  display: grid;

  grid-template-columns: repeat(4, 1fr);

  gap: 18px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;

  gap: 7px;

  grid-column: span ${(props) => props.$span || 1};

  label {
    color: #4f5b65;

    font-size: 13px;
    font-weight: 600;
  }

  input,
  select,
  textarea {
    width: 100%;

    box-sizing: border-box;

    border: 1px solid #dce1e6;
    border-radius: 7px;

    padding: 10px 12px;

    background: #ffffff;

    color: #39434d;

    font-size: 14px;

    outline: none;

    transition:
      border 0.2s ease,
      box-shadow 0.2s ease;

    &:focus {
      border-color: #2e7d6e;

      box-shadow: 0 0 0 3px rgba(46, 125, 110, 0.1);
    }

    &::placeholder {
      color: #adb5bd;
    }
  }

  @media (max-width: 700px) {
    grid-column: span 1;
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 6px;

  grid-column: span 2;

  small {
    color: #8a949d;
    font-size: 12px;
  }

  @media (max-width: 700px) {
    grid-column: span 1;
  }
`;

export const StatusLabel = styled.label`
  display: flex;
  align-items: center;

  gap: 9px;

  color: #4f5b65;

  font-size: 14px;
  font-weight: 600;

  cursor: pointer;

  input {
    width: 17px;
    height: 17px;

    accent-color: #2e7d6e;

    cursor: pointer;
  }
`;

export const FormActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 10px;

  padding-top: 24px;
  margin-top: 28px;

  border-top: 1px solid #edf0f3;
`;

export const SecondaryButton = styled.button`
  border: 1px solid #d8dee4;

  background: #ffffff;
  color: #58636e;

  padding: 10px 18px;

  border-radius: 8px;

  font-size: 14px;
  font-weight: 600;

  cursor: pointer;

  transition:
    background 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background: #f5f7f9;
    border-color: #c8cfd6;
  }
  
`;
export const FieldInfo = styled.span`
  color: #6f7d86;
  font-size: 12px;
`;

export const FieldError = styled.span`
  color: #c62828;
  font-size: 12px;
`;
